export const COOKIES_ACCESS_TOKEN = "COOKIES_ACCESS_TOKEN";
export const COOKIES_CLIENT_ID = "COOKIES_CLIENT_ID";
